<template>
  <div class="cmpt">
    <div v-show="!loaded" v-html="info" :style="infoStyle" />
    <div v-show="loaded">
      <b-button :disabled="loading || !validForm" block variant="warning"
        @click="handleCreateStripeOrder()">Donate</b-button>
      <h5 v-show="statusInfo" :style="statusInfoStyle">{{ statusInfo }}</h5>
      <h2>
        {{ formData.title }}
      </h2>
      <b-form-group label-cols-sm="2" label="Amount:" label-for="id-amount-field"
        label-align-sm="right" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="id-amount-field"
          v-model="formData.amount"
          :options="amountList"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-primary"
          size="md"
          name="amount-field"
          buttons></b-form-radio-group>
      </b-form-group>
      <!-- <label for="input-email">eMail: </label> -->
      <b-form-group label-cols-sm="2" label="eMail:" label-for="id-email-field"
        label-align-sm="right">
        <b-form-input
          id="id-email-field"
          v-if="formData.emailField !== 'no'"
          v-model="formData.email"
          type="email"
          required
          :state="validEmail"
          placeholder="eMail"/>
      </b-form-group>
      <b-form-group label-cols-sm="2" label="Name:" label-for="id-name-field"
        label-align-sm="right">
        <b-form-input
          id="id-name-field"
          v-if="formData.nameField !== 'no'"
          v-model="formData.name"
          type="text"
          required
          :state="validName"
          placeholder="Full name"/>
      </b-form-group>
      <div>Karetendaten:</div>
      <template v-slot:stripecardslot>
        <!-- <slot name="stripecardslot"></slot> -->
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import * as htmlUtil from '@/service/utils/html'
import { PIT_DEFS } from '@/service/utils/constants'

function _getDefaultInfoStyle () {
  return { 'text-align': 'left', color: 'green' }
}

function _getErrorInfoStyle () {
  return { 'text-align': 'left', color: 'red' }
}

function _getDefaultFormData () {
  return {
    email: '',
    name: '',
    amount: null
  }
}

export default {
  name: 'gl-donation',
  version: '0.0.1',
  props: {
    paymInstKey: {
      type: String,
      required: false
    },
    contentKey: {
      type: String,
      required: true
    },
    genSeo: {
      type: Boolean,
      default: false
    }
  }, // props
  components: {}, // components
  data () {
    return {
      loading: false,
      loaded: false,
      info: '... loading content!',
      infoStyle: _getDefaultInfoStyle(),
      statusInfo: '',
      statusInfoStyle: _getDefaultInfoStyle(),
      stripe: {
        inst: null,
        elements: null,
        card: null,
        cardValid: false
      },
      formData: _getDefaultFormData(),
      amountList: []
    }
  }, // data
  /* ----- vuejs hooks ----- */
  async mounted () {
    this.loaded = false
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)

      const _contentData = resp.data.payload.content
      this.formData = _contentData.fragments
      this.amountList = _contentData.fragments.amountList
      if (this.genSeo && _contentData.jsonld) {
        htmlUtil.addJsonldToHead(_contentData.jsonld)
      }
      this.formData.amount = this.amountList[0]

      const _glapiPaymResp = await axios.get(config.glapiBaseUri + '/paym/' +
        this.paymInstKey + '/preferedPIDetails')

      if ('success' === _glapiPaymResp.data.status) {
        this.piType = _glapiPaymResp.data.payload.ppiDetails.piType
        this.piMerchantId = _glapiPaymResp.data.payload.ppiDetails.merchantId
        if (this.piType === PIT_DEFS.pitStripe) {
          // this.loadStripeSdk()
          const _allDonationEl = document.getElementsByTagName('glcwc-content-donation')
          if (_allDonationEl.length > 1) {
            this.loaded = false
            this.info = 'More than one donation element detected! Please remove the ambiguous elements!'
            console.log('TRACE-REMOVE: mounted: More than one donation element!')
            return
          }
          const slotEl = document.createElement('div')
          slotEl.setAttribute('slot', 'stripecardslot')
          slotEl.setAttribute('style', 'max-width: 600px;')
          const stripeCardErrEl = document.createElement('div')
          stripeCardErrEl.setAttribute('id', 'stripe-card-errors')
          stripeCardErrEl.setAttribute('role', 'alert')
          stripeCardErrEl.setAttribute('style', 'color: red;')
          slotEl.append(stripeCardErrEl)
          const stripeCardEl = document.createElement('div')
          stripeCardEl.setAttribute('id', 'stripe-card-element')
          slotEl.append(stripeCardEl)
          _allDonationEl[0].parentNode.append(slotEl)
          this.loadStripeSdk()
          // this.mountStripeElements()
        } else {
          throw new Error('Payment integration [' + this.piType + '] not supported!')
        }
      } else {
        throw new Error('Payment API call failed! Status: ' + _glapiPaymResp.data)
      }

      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  computed: {
    validForm () {
      return this.validName && this.validEmail && this.validCard
    }, // validForm
    validEmail () {
      let _ret = true
      if (this.formData.emailField === 'mandatory') {
        if (!this.formData.email || this.formData.email === '') {
          _ret = false
        }
      }
      return _ret
    }, // validEmail
    validName () {
      let _ret = true
      if (this.formData.nameField === 'mandatory') {
        if (!this.formData.name || this.formData.name === '') {
          _ret = false
        }
      }
      return _ret
    }, // validName
    validCard () {
      return this.stripe.cardValid
    } // validCard
  }, // computed
  watch: {}, // watch
  methods: {
    /* ----- utility methods ----- */
    loadStripeSdk () {
      console.log('INFO: loading StripeSdk ...')
      const script = document.createElement('script')
      script.src = config.stripeSdkUrl
      script.async = false
      script.addEventListener('load', () => {
        // eslint-disable-next-line
        this.stripe.inst = Stripe(config.stripePlatformPK, {
          apiVersion: '2020-08-27',
          stripeAccount: this.piMerchantId
        })
        this.stripe.elements = this.stripe.inst.elements()
        this.stripe.card = this.stripe.elements.create('card')
        // card.mount('#card-element');
        console.log('INFO: StripeSdk loaded!')
        console.log('TRACE-REMOVE: stripe-card-element is: ', document.getElementById('stripe-card-element'))
        this.stripe.card.mount('#stripe-card-element')
        this.stripe.card.on('change', ({ complete, error }) => {
          let displayError = document.getElementById('stripe-card-errors')
          if (complete) {
            displayError.textContent = ''
            this.stripe.cardValid = true
          } else if (error) {
            displayError.textContent = error.message
            this.stripe.cardValid = false
          } else {
            displayError.textContent = ''
            this.stripe.cardValid = false
          }
        })
        console.log('INFO: Donation: Stripe elements mounted!')
      })
      document.body.appendChild(script)
    }, // loadStripeSdk
    mountStripeElements () {
      this.stripe.card.mount('#stripe-card-element')
      this.stripe.card.on('change', ({ error }) => {
        let displayError = document.getElementById('stripe-card-errors')
        if (error) {
          displayError.textContent = error.message
        } else {
          displayError.textContent = ''
        }
      })
      console.log('INFO: Stripe elements mounted!')
    }, // mountStripeElements
    async handleCreateStripeOrder () {
      try {
        this.loading = true
        console.log('INFO: Donation: PO creation started!')
        const _resp = await axios.post(config.glapiBaseUri + '/paym/' +
          this.paymInstKey + '/paymentOrder/pit-stripe',
          { amount: this.formData.amount })
        console.log('INFO: Donation: PO created!')
        const _donor = this.formData.name ? this.formData.name : 'Anonymous'
        const _result = await this.stripe.inst.confirmCardPayment(
          _resp.data.payload.paymentOrder.pmIntnClientSecret, {
            payment_method: {
              card: this.stripe.card,
              billing_details: {
                name: _donor
              }
            }
          })
        if (_result.error) {
          console.error('INFO: Donation: PO confirmed error! Error is: ', _result.error)
          this.orderSuccSent = false
        } else {
          // The payment has been processed!
          if (_result.paymentIntent.status === 'succeeded') {
            console.log('INFO: Donation: PO confirmed success!')
            const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
            let iter = 0
            let finalized = false
            while (!finalized && iter++ < 3) {
              try {
                await sleep(3000)
                const _resp2 = await axios.put(config.glapiBaseUri + '/paym/' +  // eslint-disable-line no-unused-vars
                  this.paymInstKey + '/paymentOrder/pit-stripe',
                  { orderId: _resp.data.payload.paymentOrder.ppOrderId }
                )
                console.log('INFO: Donation: PO finalized!')
                this.formData = _getDefaultFormData()
                this.formData.amount = this.amountList[0]
                finalized = true
              } catch (e2) {
                console.log('ERROR: OrderBasketBtn: Order still not finalized! Exception is: ', e2)
              }
            }
            this.orderSuccSent = finalized
          }
        }
      } catch (e) {
        console.log('ERROR: Donation: exception is: ', e)
        this.orderSuccSent = false
      // } finally {
      //   this.loading = false
      }
      if (this.orderSuccSent) {
        this.statusInfo = 'Donation successfully completed!'
        this.statusInfoStyle = _getDefaultInfoStyle()
      } else {
        this.statusInfo = 'Donation could not be completed due to an error!'
        this.statusInfoStyle = _getErrorInfoStyle()
      }
      setTimeout(() => {
        this.statusInfo = ''
        this.loading = false
      }, 10000)

    } // handleCreateStripeOrder
  } // methods
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
.cmpt {
  max-width: 600px;
}
</style>
